shadow$provide[6] = function(require,module,exports) {
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.useThreestrap = exports.Controls = exports.Renderer = void 0;
var Renderer_1 = require("./Renderer");
__createBinding(exports, Renderer_1, "default", "Renderer");
var Controls_1 = require("./Controls");
__createBinding(exports, Controls_1, "default", "Controls");
var ThreestrapContext_1 = require("./ThreestrapContext");
__createBinding(exports, ThreestrapContext_1, "useThreestrap");
//# sourceMappingURL=index.js.map
};